import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export default function About() {
  const title = 'Profil | Tømrerfirmaet Hansen og Mortensen Fredensborg'
  const description = 'Hvem er vi? Tømrer med stor erfaring i København og Nordsjælland Vi er to tømrere Jan Hansen og Jan Mortensen der efter at have gået som makkerpar i en del år, blev enige om at starte Tømrerfirmaet Hansen & Mortensen I 1997. I 2016 blev vi yderligere en medejer Tim Nielsen efter at have været ... Læs Mere'

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="https://assets.auxodev.dk/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-4-bannerimg-1.png" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      {/* Hero Banner */}
      <section className="relative h-[45vh] min-h-[350px] w-full bg-neutral-950 flex items-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-4-bannerimg-1.png"
            alt="Profil"
            className="w-full h-full object-cover opacity-35"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-neutral-950/60 to-transparent" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-left">
          <div className="flex items-center gap-2 text-xs text-red-500 uppercase tracking-[0.2em] font-extrabold mb-3">
            <Link to="/" className="hover:text-red-400 transition-colors">Forside</Link>
            <span className="text-zinc-600">/</span>
            <span className="text-white">Profil</span>
          </div>
          <h1 className="text-4xl sm:text-6xl font-black text-white uppercase tracking-tight leading-none mb-4" style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.8)' }}>
            Profil
          </h1>
          <div className="w-24 h-[4px] bg-red-700 mb-6" />
          <p className="text-base sm:text-lg text-zinc-200 max-w-3xl font-medium leading-relaxed" style={{ textShadow: '1px 1px 4px rgba(0,0,0,0.8)' }}>
            Lad os stå for din næste opgave. Her kan du få et indblik i, hvad vi kan hjælpe dig med på dette område.
          </p>
        </div>
      </section>

      {/* Quick Contact Bar */}
      <div className="bg-zinc-100 border-b border-zinc-200 py-4 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-wrap gap-6 justify-start items-center text-xs sm:text-sm font-bold uppercase tracking-wider text-neutral-950">
          <a href="tel:22115514" className="flex items-center gap-2 hover:text-red-700 transition-colors">
            <i className="fa-solid fa-phone text-red-700" />
            (+45) 22 11 55 14
          </a>
          <span className="text-zinc-300 hidden sm:inline">|</span>
          <a href="mailto:hogm@hansenogmortensen.dk" className="flex items-center gap-2 hover:text-red-700 transition-colors">
            <i className="fa-solid fa-envelope text-red-700" />
            hogm@hansenogmortensen.dk
          </a>
        </div>
      </div>

      {/* Section: Hvem er vi? */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Left Column: Text */}
            <div className="lg:col-span-7 flex flex-col gap-8">
              <div className="space-y-2">
                <span className="text-red-700 text-xs font-extrabold uppercase tracking-widest block">
                  Tømrerfirmaet Hansen &amp; Mortensen
                </span>
                <h2 className="text-3xl sm:text-4xl font-black text-neutral-950 uppercase tracking-tight">
                  Hvem er vi?
                </h2>
                <div className="w-16 h-1 bg-red-700" />
              </div>

              <div className="space-y-8 text-zinc-700 text-sm sm:text-base leading-relaxed">
                <div className="border-l-4 border-red-700 pl-4 space-y-2">
                  <h3 className="font-black text-neutral-950 text-lg uppercase tracking-tight">
                    Tømrer med stor erfaring i København og Nordsjælland
                  </h3>
                  <p className="text-zinc-600 font-medium">
                    Vi er to tømrere Jan Hansen og Jan Mortensen der efter at have gået som makkerpar i en del år, blev enige om at starte Tømrerfirmaet Hansen &amp; Mortensen I 1997. I 2016 blev vi yderligere en medejer Tim Nielsen efter at have været medarbejder i 10 år.​
                  </p>
                </div>

                <div className="border-l-4 border-neutral-950 pl-4 space-y-2">
                  <h3 className="font-black text-neutral-950 text-lg uppercase tracking-tight">
                    Kvalitet, ansvarlighed og ærlighed
                  </h3>
                  <p className="text-zinc-600 font-medium">
                    Kvalitet, ansvarlighed og ærlighed er stadig vores hovedfokus. Vi bruger udelukkende de bedste materialer og holder os konstant opdaterede omkring de nyeste teknikker og værktøjer. Vi har et fantastisk samarbejde med vores underleverandører inden for både VVS, EL og malerfaget, og vi er derfor i stand til at udføre næsten alle håndværksmæssige opgaver.​
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column: Image */}
            <div className="lg:col-span-5 relative">
              <div className="absolute -left-4 -top-4 w-12 h-12 border-l-4 border-t-4 border-red-700 hidden sm:block" />
              <div className="absolute -right-4 -bottom-4 w-12 h-12 border-r-4 border-b-4 border-neutral-950 hidden sm:block" />
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-13-mand-maaler-trae.png"
                alt="Tømrer Jan Hansen, Jan Mortensen og Tim Nielsen"
                className="w-full h-[450px] object-cover shadow-2xl border-4 border-neutral-950 rounded-none"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Section: Dialogen med kunden er vigtig */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-zinc-50 border-y border-zinc-200">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Left Column: Image */}
            <div className="lg:col-span-5 order-2 lg:order-1 relative">
              <div className="absolute -right-4 -top-4 w-12 h-12 border-r-4 border-t-4 border-red-700 hidden sm:block" />
              <div className="absolute -left-4 -bottom-4 w-12 h-12 border-l-4 border-b-4 border-neutral-950 hidden sm:block" />
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/imgi-5-mand-loefter-trae.png"
                alt="Tømrerarbejde kvalitet"
                className="w-full h-[450px] object-cover shadow-2xl border-4 border-neutral-950 rounded-none"
              />
            </div>

            {/* Right Column: Text */}
            <div className="lg:col-span-7 order-1 lg:order-2 flex flex-col gap-6">
              <div className="space-y-2">
                <span className="text-red-700 text-xs font-extrabold uppercase tracking-widest block">
                  Tæt samarbejde
                </span>
                <h2 className="text-3xl sm:text-4xl font-black text-neutral-950 uppercase tracking-tight">
                  Dialogen med kunden er vigtig
                </h2>
                <div className="w-16 h-1 bg-red-700" />
              </div>

              <div className="space-y-6 text-zinc-700 text-sm sm:text-base leading-relaxed">
                <p className="font-bold text-neutral-950 text-base sm:text-lg">
                  For os er dialog med vores kunder et meget vigtigt aspekt og vi opdaterer derfor altid vores kunder løbende under hele byggeprocessen.
                </p>
                <p>
                  Dette fører til en tilfredsstilende proces og et endeligt resultat helt i tråd med kundens oprindelige ønske. Vi tilbyder alle former for opgaveløsninger fra mindre reparationer til hovedentrepriser i både den private og offentlige sektor.
                </p>
                <div className="bg-red-700 text-white p-6 border-l-8 border-neutral-950 rounded-none shadow-md">
                  <p className="text-lg sm:text-xl font-black uppercase tracking-tight">
                    Vi udfører alle opgaver – store som små.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section: Kontakt os i dag for tagarbejde i København */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center gap-6">
          <span className="text-red-700 text-xs font-extrabold uppercase tracking-widest">
            Søg efter tømrer?
          </span>
          <h2 className="text-2xl sm:text-3xl font-black text-neutral-950 uppercase tracking-tight">
            Kontakt os i dag for tagarbejde i København
          </h2>
          <div className="w-16 h-1 bg-red-700" />
          <p className="text-zinc-600 text-sm sm:text-base leading-relaxed max-w-2xl">
            Kontakt os i dag, hvis du søger efter en tømrer til tagarbejde i København. Du er velkommen til at kontakte os ved at ringe til <a href="tel:22115514" className="text-red-700 font-extrabold hover:underline">+45 22 11 55 14</a> eller sende en mail til <a href="mailto:hogm@hansenogmortensen.dk" className="text-red-700 font-extrabold hover:underline">hogm@hansenogmortensen.dk</a>. Vi ser frem til at høre fra dig!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mt-4 w-full sm:w-auto">
            <a
              href="tel:22115514"
              className="bg-neutral-950 hover:bg-neutral-900 text-white text-xs font-bold uppercase tracking-widest px-8 py-4 transition-all duration-300 rounded-none flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-phone" /> Ring op nu
            </a>
            <a
              href="mailto:hogm@hansenogmortensen.dk"
              className="bg-red-700 hover:bg-red-800 text-white text-xs font-bold uppercase tracking-widest px-8 py-4 transition-all duration-300 rounded-none flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-envelope" /> Send e-mail
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}
